<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Editar tarefa</h2>
    <FormTask :baseTask="task" @submit-requested="submitRequested"></FormTask>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormTask from '../forms/FormTask.vue'
import router from '@/router';

  export default {
  components: { FormTask },
    computed:{
      ...mapState('tasks', ['taskOutput']),
      task: function()
      {
        return this.taskOutput && this.taskOutput.obj ? this.taskOutput.obj.task : null;
      }
    },
    methods: {
      ...mapActions('tasks', ['editTask']),
      ...mapActions('tasks', ['getTask']),
      submitRequested (task) {
        this.editTask(task);
      },
    },
    mounted: function()
    {
      if(!this.$route.params.id)
      {
        router.push({ path: '/tarefas/lista' });
      }
      else
      {
        this.getTask(this.$route.params.id);
      }
    }
  }
</script> 
 
<style scoped>
</style> 